import React from 'react';
export function Footer() {
  return <footer className="bg-black py-8 px-3" data-id="element-75">
      <div className="max-w-4xl mx-auto text-center space-y-3" data-id="element-76">
        <p className="font-display text-lg text-accent font-semibold" data-id="element-77">
          SALUDENTUPLATO™
        </p>
        <div className="flex flex-col items-center justify-center gap-1 mb-4 text-sm text-white/60" data-id="element-78">
          <a href="mailto:soporte@megapacknutrideportiva.com" className="hover:text-accent transition-colors" data-id="element-79">
            📧 soporte@saludentuplato.com
          </a>
          <a href="https://instagram.com/megapacknutrideportiva" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors" data-id="element-80">
            📲 @saludentuplato.oficial
          </a>
        </div>
        <p className="text-xs text-white/30 mt-4" data-id="element-81">
          © Salud en tu plato™ 2026 — Todos los derechos reservados. Prohibida
          la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}